__turbopack_context__.v({
  "column": "ApplyFormApplicationType-module__pGQMmG__column",
  "columns": "ApplyFormApplicationType-module__pGQMmG__columns",
  "container": "ApplyFormApplicationType-module__pGQMmG__container",
  "divider": "ApplyFormApplicationType-module__pGQMmG__divider",
  "fadeInItems": "ApplyFormApplicationType-module__pGQMmG__fadeInItems",
  "field": "ApplyFormApplicationType-module__pGQMmG__field",
  "representationName": "ApplyFormApplicationType-module__pGQMmG__representationName",
  "selectField": "ApplyFormApplicationType-module__pGQMmG__selectField",
  "selectInput": "ApplyFormApplicationType-module__pGQMmG__selectInput",
  "selectOption": "ApplyFormApplicationType-module__pGQMmG__selectOption",
  "selectOptions": "ApplyFormApplicationType-module__pGQMmG__selectOptions",
  "spacing--lg": "ApplyFormApplicationType-module__pGQMmG__spacing--lg",
  "spacing--md": "ApplyFormApplicationType-module__pGQMmG__spacing--md",
  "spacing--sm": "ApplyFormApplicationType-module__pGQMmG__spacing--sm",
  "spacing--xl": "ApplyFormApplicationType-module__pGQMmG__spacing--xl",
  "spacing--xs": "ApplyFormApplicationType-module__pGQMmG__spacing--xs",
  "spacing--xxl": "ApplyFormApplicationType-module__pGQMmG__spacing--xxl",
  "spacing--xxs": "ApplyFormApplicationType-module__pGQMmG__spacing--xxs",
  "spacing--xxxl": "ApplyFormApplicationType-module__pGQMmG__spacing--xxxl",
  "spacing--xxxs": "ApplyFormApplicationType-module__pGQMmG__spacing--xxxs",
  "text": "ApplyFormApplicationType-module__pGQMmG__text",
  "title": "ApplyFormApplicationType-module__pGQMmG__title",
});
